import styled from 'styled-components/macro';

export const AppWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
